import { render, staticRenderFns } from "./AllProjectActions.vue?vue&type=template&id=49999752&"
import script from "./AllProjectActions.vue?vue&type=script&lang=js&"
export * from "./AllProjectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports